/**
 * Singleton hook to check if multiple elements can be dismissed and returns flag only for the latest one
 * Example: Use to only close the latest opened Flyout/Modal
 */
import React from "react";
import useElementId from "../useElementId.js";
let queue = {};
let latestId = null;
const removeFromQueue = (id) => {
    // Ignore removal of non-existing ids when called on component mount with active: false
    if (!queue[id])
        return;
    if (id === latestId)
        latestId = queue[id].parentId;
    delete queue[id];
    // Clear up all unused ids after the queue is resolved
    if (latestId === null)
        queue = {};
};
const addToQueue = (id, contentRef, triggerRef) => {
    queue[id] = { parentId: latestId, triggerRef, contentRef };
    latestId = id;
};
const useIsDismissible = (args) => {
    const { active, contentRef, triggerRef, blocking } = args;
    const id = useElementId();
    const isDismissible = React.useCallback(() => {
        if (!blocking)
            return true;
        return active ? latestId === id : true;
    }, [id, active, blocking]);
    React.useEffect(() => {
        if (!active)
            return;
        addToQueue(id, contentRef, triggerRef);
        return () => removeFromQueue(id);
    }, [active, id, contentRef, triggerRef]);
    return isDismissible;
};
export default useIsDismissible;
